import SingleFileupload from '@/components/common/fileupload/single/SingleFileupload.vue'
export default {
  data () {
    return {
      clientApiId: '',
      editEl: null,
      loading: false
    }
  },
  components: {
    SingleFileupload
  },
  computed: {
    getTitle () {
      return this.$t('menu.bills.edit', { billnumber: (this.editEl ? this.editEl.bill_number : '') });
    }
  },
  methods: {
    show (elData, clientApiId) {
      this.editEl = this.BasicHelper.cloneObject(elData);
      this.clientApiId = clientApiId;
      this.editEl.files = [this.editEl.file];
      this.$refs['modal-window'].show();
    },
    save () {
      const reqData = this.ApiRequest.createFormData(this.editEl, [], 'bill', this, true);
      if (!this.loading && reqData) {
        this.loading = true;
        const self = this;
        this.ApiRequest.request('client-bill/edit/' + this.clientApiId + '/' + this.editEl.id, this.ApiRequest.REQUEST_FILEUPLOAD, reqData, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          } else {
            self.$emit('saved', response.data);
            self.close();
          }
          self.loading = false;
        });
      }
    },
    close () {
      this.$refs['modal-window'].hide();
    }
  }
}
